import { React, useState }  from "react";
import axios from 'axios';

import "./EditShelfModal.css";
import xIcon from "../../assets/images/x-icon.svg";
import { API_BASE_URL } from "../../Variables";

/**
 * Edit Shelf Modal component
 * Used for editing the name of a shelf
 * Only allowed for custom shelves
 * @param {*} shelfId - Id of the shelf
 * @param {*} shelfName - Name of the shelf
 * @param {*} onClose - Function to close the modal
 * @param {*} onNameChange - Function to update the shelf name
 * @returns 
 */
function EditShelfModal( {shelfId, shelfName, onClose, onNameChange} ) {
  const token = localStorage.getItem('token');
  const [newShelfName, setNewShelfName] = useState(shelfName || "");
  const [error, setError] = useState(null);

  /**
   * Ensure the shelf name is not empty
   * Update the shelf name
   * and close the modal
   * @returns - Save the new shelf name
   */
  const handleSave = async () => {
    if (newShelfName.trim() === "") {
      setError("Shelf name cannot be empty.");
      return;
    }

    try {
      await axios.put(`${API_BASE_URL}/shelves/${shelfId}`, 
        { name: newShelfName },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onNameChange(newShelfName);
      onClose(false);
    } catch (error) {
      setError('Failed to save shelf name.');
    }
  };

  return (
    <div className="modal-overlay">
      <div className="edit-shelf-modal">
        <div className="modal-header">
          <img src={xIcon} alt="Close" onClick={() => onClose(false)} className="modal-close"/>
        </div>
        <input type="text" placeholder="Enter new shelf name" value={newShelfName} 
          onChange={(e) => {
            setNewShelfName(e.target.value);
            setError(null);
          }}
          className="modal-input"
        />
        {error && <p className="error">{error}</p>}
        <button onClick={handleSave} className="tertiary-button">Save</button>
      </div>
    </div>
  );
}

export default EditShelfModal;
